import { useTranslation } from 'react-i18next';

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

/** «Показать архивные» — локальный фильтр списка, по умолчанию выключен. */
export function ShowArchivedCheckbox({ checked, onChange }: Props) {
  const { t } = useTranslation();
  return (
    <label
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        color: 'var(--text-2)',
        cursor: 'pointer',
        padding: '7px 12px',
        border: '1px solid var(--line)',
        borderRadius: 6,
        background: 'var(--bg-elev)',
        fontSize: 12,
        fontWeight: 500,
      }}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      {t('archive.showArchived')}
    </label>
  );
}
